import { queryDevtoolsOpenAtom } from "@/components/layout/queryDevtoolsAtom.ts";
import { SHOW_QUERY_DEVTOOLS } from "@/lib/devFlags.ts";
import { ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools";
import { useAtom } from "jotai";

/**
 * The React Query devtools panel, rising from the foot of the screen.
 *
 * `ReactQueryDevtoolsPanel` rather than `ReactQueryDevtools`, which is the same
 * panel plus a floating toggle of its own — a second control for the one the
 * header already carries, and one that puts itself back in the corner this
 * change is clearing.
 *
 * Mounted at the app root rather than beside that header control, because the
 * panel is `position: fixed` and every panel header is a container-query
 * context: `container-type` applies `contain: layout`, which makes the header a
 * containing block for fixed descendants. Inside one, the panel resolved
 * against a 56px row and opened as a sliver across the top of the screen.
 */
export const QueryDevtools = () => {
  const [open, setOpen] = useAtom(queryDevtoolsOpenAtom);

  if (!SHOW_QUERY_DEVTOOLS || !open) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-9999">
      <ReactQueryDevtoolsPanel onClose={() => setOpen(false)} />
    </div>
  );
};
